import { AlpineComponent } from 'alpinejs';

export interface VideoInterface {
  video_player: HTMLVideoElement | null;
  active: boolean;
  toggle(): void;
  triggerControl(): void;
}

const Video = ({
  video_player,
  active,
}: {
  video_player: HTMLVideoElement | null;
  active: boolean;
}): AlpineComponent<VideoInterface> => ({
  video_player: video_player,
  active: active,
  init(): void {
    this.$watch('active', () => this.triggerControl());
  },
  triggerControl(): void {
    this.active ? this.video_player?.play() : this.video_player?.pause();
  },
  toggle(): void {
    this.active = !this.active;
  },
});

export default Video;
